import { render, staticRenderFns } from "./LimitProductList.vue?vue&type=template&id=06ba9887&"
import script from "./LimitProductList.vue?vue&type=script&lang=js&"
export * from "./LimitProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports